import React from 'react';
import { Card, Button, Typography, Image } from 'antd';
import { PlusOutlined } from '@ant-design/icons'; // For a generic "Add" button icon

const { Paragraph } = Typography;

const SectionCard = ({
    title,
    description,
    icon, // This will be the Ant Design icon component (e.g., <UserOutlined />)
    buttonText,
    onAddClick,
    children, // This is where PersonalInformationView or the form will be rendered
    hasData // New prop to determine if data exists for this section
}) => {
    return (
        <Card
            className="card-main" title={title}
        >
            {/* <Title level={3} style={{ textAlign: 'center', marginBottom: '24px' }} className="card-head-title">{title}</Title> */}

            {hasData ? (
                // Render children (e.g., PersonalInformationView) if data exists
                children
            ) : (
                // Render initial "add" state if no data
                <>
                    <Paragraph style={{ textAlign: 'center', maxWidth: '600px', margin: '0 auto 32px' }}>
                        {description}
                    </Paragraph>
                    <div className="card-icon">
                        <div className="volunteer-feature">
                            <Image
                                alt="image"
                                preview={false}
                                width={80}
                                src={icon}
                                style={{ display: "inline-block" }}
                            />
                        </div>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                        <Button
                            className="add-button-style"
                            type="primary"
                            onClick={onAddClick}
                            icon={<PlusOutlined />}
                            shape='round'
                        >
                            {buttonText}
                        </Button>
                    </div>
                </>
            )}
        </Card>
    );
};

export default SectionCard;